import { render, staticRenderFns } from "./AdminUserManager.vue?vue&type=template&id=07670d00&"
import script from "./AdminUserManager.vue?vue&type=script&lang=js&"
export * from "./AdminUserManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports